import React from 'react';
import { CdsContentPanel } from 'clayco-component-library';

const StayBenefitPolicyPanel = ({
  successMessage,
  isLoading,
  loadError,
  onAdd,
  children
}) => (
  <CdsContentPanel
    title={<span>Stay Benefit Form</span>}
    collapsible={false}
    primaryButtonText="Add Non-Travel Period"
    primaryButtonSubmits={false}
    primaryButtonHandler={onAdd}
  >
    <div className="mb-3">
      <p>Non-Travel Benefit Policy</p>
      <p>Effective October 1, 2025, employees who have not submitted or expensed any travel for a continuous 30 day period are eligible to receive a $1,000 non-travel benefit.</p>
      <p>Eligibility is determined based on verified travel expense records. Approved benefits will be processed and included in an upcoming pay period following confirmation of eligibility.</p>
      <p>This benefit applies only to employees who are eligible to receive per diem.</p>
      <p>Requests must be submitted and approved by end of day Monday to be included in the current week&rsquo;s paycheck.</p>
    </div>
    {successMessage && <div className="alert alert-success py-2" role="alert">{successMessage}</div>}
    {isLoading && <div className="small text-muted">Loading submissions...</div>}
    {loadError && <div className="alert alert-danger py-2" role="alert">{loadError}</div>}
    {children}
  </CdsContentPanel>
);

export default StayBenefitPolicyPanel;
